import React, { useEffect, useState } from "react";
import {
  classesURL,
  reportsClassesURL,
  reportsURL,
  studentURL,
} from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import { useLocation, useParams } from "react-router-dom";
import ClassFeedback from "../../Templates/Reports/ClassFeedback/ClassFeedback";
import useEdit from "../../Hooks/useEdit";
import useSave from "../../Hooks/useSave";
import useFetchWhen from "../../Hooks/useFetchWhen";

function ClassFeedbackPage() {
  let { id, report_id, student_id, feedback_id } = useParams();
  const [student, setStudent] = useState(null);
  const {
    data: studentData,
    loading: studentLoading,
    error: studentError,
  } = useFetch(`${studentURL}/${student_id}`);
  const [feedback, setFeedback] = useState(null);
  const { data, loading, error } = useFetch(
    `${classesURL}/${id}/class-feedbacks/${report_id}/feedbacks/${feedback_id}`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setFeedback(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!studentLoading && !studentError && studentData) {
      setStudent(studentData.data);
    }
  }, [studentData, studentLoading, studentError]);

  return (
    <ClassFeedback
      feedback={feedback}
      loading={loading}
      classId={id}
      student={student}
    />
  );
}

export default ClassFeedbackPage;
